import { Component, OnInit } from '@angular/core';
import { QuotesHistoryTableComponent } from '../quotes-history-table/quotes-history-table.component';
import { DatePickerModule } from 'primeng/datepicker';
import { FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Quote } from '../../../../../core/models/quotes.model';
import { I18nModule } from '@spartacus/core';
import { PageTitle } from '../../../store-front/misc/page-title/page-title.component';
import { QuotesService } from '../../core/quotes.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AllowedKeysToDatePickerModule } from '../../../../../core/directives/allowed-keys-to-date-picker/allowed-keys-to-date-picker.module';

@Component({
  selector: 'quotes-history-form',
  standalone: true,
  imports: [
    QuotesHistoryTableComponent,
    DatePickerModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    PageTitle,
    CommonModule,
    AllowedKeysToDatePickerModule,
  ],
  templateUrl: './quotes-history-form.component.html',
  styleUrl: './quotes-history-form.component.scss',
})
export class QuotesHistoryFormComponent implements OnInit {
  dateRangeForm!: FormGroup;
  quotes$?: Observable<Quote[]>;
  constructor(
    private fb: FormBuilder,
    protected quotesService: QuotesService,
    protected router: Router,
  ) {}

  ngOnInit(): void {
    this.buildDateForm();
  }

  buildDateForm() {
    const today = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(today.getMonth() - 6);

    this.dateRangeForm = this.fb.group({
      fromDate: [sixMonthsAgo],
      toDate: [today],
    });
  }

  onSearch() {
    const { fromDate, toDate } = this.dateRangeForm.value;
    const formattedFromDate = fromDate ? new Date(fromDate).toISOString().split('T')[0] : '';
    const formattedToDate = toDate ? new Date(toDate).toISOString().split('T')[0] : '';
    this.getQuoteHistory(formattedFromDate, formattedToDate);
  }

  getQuoteHistory(from: string, to: string) {
    this.quotes$ = this.quotesService.getQuoteHistory(from, to);
  }

  navigate() {
    this.router.navigate(['/quotes']);
  }
}
